import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

//Components
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon,
} from "@mui/material";
import { Loading, Tooltip, Tabs, TabContainer } from "@gpstrackit/react-controls"
import SummaryCard from 'Components/SummaryCard';
import MultiLevelSelector from "Components/SelectorMultiLevel";

//Tabs
import Activities from 'Modules/activities/.components/tab';
import Features from 'Modules/packages/.components/featureTab';
import AssignedTo from 'Modules/packages/.components/assignedToTab';
import CreateEditPackage from 'Modules/packages/.components/createEditPackage';

//Actions
import { packagesOverviewRequest, packagesCreateEditOpenModal } from 'Redux/actions';

//Permission
import { HasPermission } from "Core/security"

const PackageOverview = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const [openSummary, setOpenSummary] = useState(true)
    const [tab, setTab] = useState(0);

    const { currentPackage, loading } = useSelector(state => state.packageOverviewRedux);
    const openModal = useSelector(state => state.createEditPackageRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const SummaryItem = (props) => {
        const { label, value } = props;
        return (
            <Grid item xs={4} sm={4}>
                <div style={{ display: 'grid' }}>
                    <span style={{ opacity: 0.6 }} className="text-muted mb-2">
                        {label}
                    </span>
                    {
                        currentPackage ? value() : <div style={{ width: 210, height: 20 }}></div>
                    }
                </div>
            </Grid>
        )
    }

    useEffect(() => {
        dispatch(packagesOverviewRequest(id))
    }, []);

    let indexCount = 0;
    let activitiesTab = HasPermission(user, "act");
    let featureTab = HasPermission(user, "rolft");
    let assignedToTab = HasPermission(user, "rolat");


    let innerHeight = window.innerHeight

    return (
        <Container maxWidth={false} className="container-view">
            {loading && <Loading overlay show />}
            <Paper elevation={0} style={{ overflow: "auto" }}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", height: '95vh' }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={6}>
                                <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton onClick={() => navigate(-1)} size="large">
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                            arrow_back
                                        </Icon>
                                    </IconButton>
                                    <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['packages_overview_title']}:</span><div>{`  ${currentPackage?.name || ''}`}</div>
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: 'end' }}>
                                <MultiLevelSelector
                                    label={messages['device_overview_actions']}
                                    position="left"
                                    options={[
                                        {
                                            id: "edit_package",
                                            label: messages['device_overview_edit'],
                                            show: true,
                                            action: () => {
                                                dispatch(packagesCreateEditOpenModal(currentPackage?.id));
                                            },
                                            disabled: !HasPermission(user, "rol", "u")
                                        },
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>
                        <SummaryCard
                            onChange={(value) => setOpenSummary(value)}
                            name="packages-summary"
                        >
                            <Grid container>
                                <SummaryItem
                                    label={messages['packages_overview_title']}
                                    value={() => {
                                        return (
                                            <>
                                                {
                                                    currentPackage?.name ?
                                                        <Tooltip
                                                            title={currentPackage?.name || ''}
                                                        >
                                                            <div style={{
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                            }}>
                                                                {currentPackage?.name}
                                                            </div>
                                                        </Tooltip>
                                                        : <div></div>
                                                }
                                            </>


                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['packages_overview_platform']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {currentPackage?.projectId}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['packages_overview_description']}
                                    value={() => {
                                        return (
                                            <>
                                                {
                                                    currentPackage?.description ?
                                                        <Tooltip
                                                            title={currentPackage?.description || ''}
                                                        >
                                                            <div style={{
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                            }}>
                                                                {currentPackage?.description}
                                                            </div>
                                                        </Tooltip>
                                                        : <div></div>
                                                }
                                            </>


                                        )
                                    }}
                                />
                            </Grid>
                        </SummaryCard>

                        <Tabs tab={+tab} onChange={(numberTab) => { setTab(numberTab) }}>
                            {
                                activitiesTab &&
                                <TabContainer
                                    label={messages['packages_overview_activities']}
                                    index={indexCount++}
                                >
                                    <Activities
                                        tab={tab}
                                        height={openSummary ? innerHeight - 350 : innerHeight - 280}
                                        entityName="Role"
                                        entityId={id}
                                    />
                                </TabContainer>
                            }
                            {
                                featureTab &&
                                <TabContainer
                                    label={messages['packages_overview_features']}
                                    index={indexCount++}
                                >
                                    <Features
                                        currentPackage={currentPackage}
                                        height={openSummary ? innerHeight - 500 : innerHeight - 400}
                                    />
                                </TabContainer>
                            }
                            {
                                assignedToTab &&
                                <TabContainer
                                    label={messages['packages_overview_assigned_to']}
                                    index={indexCount++}
                                >
                                    <AssignedTo
                                        currentPackage={currentPackage}
                                        height={openSummary ? innerHeight - 350 : innerHeight - 280}
                                    />
                                </TabContainer>
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </Paper>
            {openModal && <CreateEditPackage getPackage={() => dispatch(packagesOverviewRequest(id))} />}
        </Container>
    );
}

export default PackageOverview;